import styled from 'styled-components';
import { colors } from '@plataforma/components';

export const Wrapper = styled.div`
  height: 184px;
  width: 864px;
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  background-color: ${colors.paleGrey};
  padding: 36px 50px;

  & > div:first-child {
    width: 145px;
    display: flex;
    align-self: center;
  }

  & > div:nth-child(2) {
    width: 525px;
  }

  & > div:last-child {
    position: absolute;
    right: 0;
    margin-top: -36px
    height: 184px;

    & > img {
      display: block;
    }
  }
`;

export const Title = styled.h2`
  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
  color: ${colors.darkBlue};
  margin: 0px;
  margin-bottom: 8px;
`;

export const Text = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: ${colors.darkBlue};
  margin: 0px;
  margin-bottom: 12px;
`;

export const LinkButton = styled.button`
  color: ${colors.electricViolet};
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  border: none;
  background: transparent;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const FidelizeLogo = styled.img`
  .carousel .slide & {
    width: 94px;
  }
`;

export const SolidShape = styled.img`
  height: 61px !important;
  width: 61px !important;
  margin-left: -61px;
`;
export const CombinedShape = styled.img`
  height: 61px !important;
  width: 61px !important;
  transform: rotate(90deg);
`;
export const CurvedShape = styled.img`
  height: 61px !important;
  width: 61px !important;
`;
